
























import { Component, Vue, Prop, Model } from 'vue-property-decorator';

@Component({
  name: 'BaseRadioCheckbox',
})
export default class BaseRadioCheckbox extends Vue {
  @Model('change') checked: boolean;
  @Prop() disabled: boolean;
  @Prop() label?: string;

  handleClick() {
    if (this.disabled) {
      return;
    }
    this.$emit('change', !this.checked);
  }

  handleFocus() {
    this.$emit('focus');
  }

  handleBlur() {
    this.$emit('blur');
  }
}
